import StoreGroceryStock from '../../types/StoreGroceryStock'
import { isStockBelowRatio } from '../../utils/stockUtils'

export interface FilterOption {
  displayText: string,
  value: 'all' | 'available' | 'almostOut' | 'out' | 'cheap'
}

export function filterFeed(feed: Array<StoreGroceryStock>, option: string) {
  if (option === 'available') {
    return [...feed.filter(g => g.quantity > 0)]
  } else if (option === 'almostOut') {
    return [...feed.filter(g => g.quantity > 0 && isStockBelowRatio({ inStockQuantity: g.quantity, restockedQuantity: g.restockedQuantity, runningOutThreshold: g.runningOutThreshold }))]
  } else if (option === 'out') {
    return [...feed.filter(g => g.quantity === 0)]
  } else if (option === 'cheap') {
    return [...feed.filter(g => g.customPrice && g.customPrice < g.ordinaryPrice)]
  }

  return feed
}

export function getFilterOptions(feed: Array<StoreGroceryStock>) : Array<FilterOption> {
  const allCount = feed.length
  const outCount = feed.filter(g => g.quantity === 0).length
  const almostOutCount = feed.filter(g => g.quantity > 0 && isStockBelowRatio({ inStockQuantity: g.quantity, restockedQuantity: g.restockedQuantity, runningOutThreshold: g.runningOutThreshold })).length
  const availableCount = allCount - (outCount)
  const cheapCount = feed.filter(g => g.customPrice && g.customPrice < g.ordinaryPrice).length
  
  return [
    { displayText: `Alla (${allCount})`, value: 'all' },
    { displayText: `Finns i skåp (${availableCount})`, value: 'available' },
    { displayText: `Snart slut (${almostOutCount})`, value: 'almostOut' },
    { displayText: `Slut (${outCount})`, value: 'out' },
    { displayText: `Billigare än ordinarie (${cheapCount})`, value: 'cheap' }
  ]
}